export default abstract class FeatureSwitchCheck<T, A extends unknown[] = []> {

  protected readonly featureSwitch: string;

  constructor(featureSwitch: string) {
    this.featureSwitch = featureSwitch;
  }

  protected abstract parseFeatureValue(featureSwitchValue: string | undefined): T;
  protected abstract doCheck(featureValue: T, ...checkArgs: A): boolean;

  public isEnabled(...checkArgs: A): boolean {
    return this.doCheck(this.parseFeatureValue(process.env[this.featureSwitch]), ...checkArgs);
  }

}
